<template>
  <div class="tencentColor" v-html="coloredText"></div>
</template>

<script>
export default {
  name: 'tencentColor',
  props: {
    text: {
      type: String,
      default: ''
    },
    SentenceComments: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      coloredText: ''
    }
  },
  methods: {
    handleColor() {
      let _text = this.text
      // console.info(this.text, this.SentenceComments)
      this.SentenceComments.forEach(({ Sentence, Suggestions }) => {
        // 替换原句
        let _res = _text.split(Sentence.Sentence)
        let _sent = ''
        let _wordArr = []
        let _word = ''
        let _reg = /\s/
        for (var i = 0; i < Sentence.Sentence.length; i++) {
          let item = Sentence.Sentence[i]
          if (
            (_reg.test(_word[_word.length - 1]) &&
              _word[_word.length - 1] !== '\n' &&
              (!_reg.test(item) || item === '\n')) ||
            /([.,!?])/g.test(item)
          ) {
            _wordArr.push(_word)
            _word = item
          } else {
            _word += item
          }
        }

        if (_word) {
          _wordArr.push(_word)
          _word = ''
        }

        _wordArr.forEach((item, index) => {
          let preFix = ''
          let suffix = ''
          Suggestions.forEach(({ ErrorPosition, Origin, ErrorType, Message }) => {
            const _ep = ErrorPosition.sort()
            if (index === _ep[0]) {
              preFix = '<div>'
            }
            if (index === _ep[1]) {
              suffix = `<span><label>${Origin}</label>【${ErrorType}】${Message}</span></div>`
            }
          })
          _sent += item.replace(/(^\s*)/, '$1' + preFix).replace(/(\s*$)/, suffix + '$1')
          console.info(_sent)
        })
        _text = _res.join(_sent)
      })

      this.coloredText = _text

      this.$nextTick(() => {
        Array.prototype.forEach.call(
          document.querySelectorAll('.tencentColor div'),
          dom => {
            dom.className = ''
            dom.removeEventListener('mouseenter', this.mouseenterFn)
            dom.removeEventListener('mouseleave', this.mouseleaveFn)
            dom.addEventListener('mouseenter', this.mouseenterFn, false)
            dom.addEventListener('mouseleave', this.mouseleaveFn, false)
          }
        )
      })
    },
    mouseenterFn(e) {
      const _box = document
        .querySelector('.question-type-bs_smbd')
        .getBoundingClientRect()
      const _el = e.target.getBoundingClientRect()

      e.target.className = 'hover'
      if (_box.bottom < _el.bottom + 260) {
        e.target.className += ' top-tip'
      }

      if (_box.right < _el.left + 230) {
        e.target.className += ' left-tip'
      }
    },
    mouseleaveFn(e) {
      e.target.className = ''
    }
  },
  watch: {
    SentenceComments(v) {
      this.handleColor()
    }
  },
  mounted() {
    this.handleColor()
  },
  destroyed() {}
}
</script>

<style lang="less">
.tencentColor {
  white-space: pre-wrap;
  div {
    position: relative;
    display: inline;
    color: #ff6666;
    text-decoration: underline;
    white-space: pre-wrap;

    &::before {
      content: '';
      display: none;
      position: absolute;
      top: 22px;
      left: 50%;
      margin-left: -7px;
      width: 14px;
      height: 8px;
      background: url(/static/images/practice/exam/triangle.png);
    }

    span {
      display: none;
      position: absolute;
      top: 30px;
      left: -7px;
      width: 222px;
      margin: 0 !important;
      padding: 4px;
      font-size: 12px;
      color: #fff !important;
      line-height: 16px;
      background: #24cc7c;
      border-radius: 2px;
      z-index: 1;

      label {
        display: block;
        line-height: 19px;
        margin-bottom: 4px;
        color: #fff;
      }
    }

    &.hover {
      span,
      &::before {
        display: block;
      }
    }

    &.top-tip {
      &::before {
        transform: rotate(180deg);
        top: auto;
        bottom: 22px;
      }

      span {
        top: auto;
        bottom: 30px;
      }
    }

    &.left-tip {
      span {
        right: -7px;
        left: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/tencentColor/main.vue